import { Component } from 'react';
import { RefreshCw } from 'lucide-react';
import Logo from './Logo';

/**
 * ErrorBoundary catches unhandled React render errors and shows a friendly
 * fallback UI instead of a blank / broken screen.
 */
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    if (window.Sentry) {
      window.Sentry.captureException(error, { extra: { componentStack: info.componentStack } });
    }
    if (process.env.NODE_ENV === 'development') {
      console.error('[ErrorBoundary] Uncaught error:', error, info.componentStack);
    }
  }

  handleReload = () => {
    this.setState({ hasError: false, error: null });
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-white text-[#0A0A0A] flex items-center justify-center px-6">
          <div className="max-w-md w-full text-center">
            <div className="mb-6 flex items-center justify-center gap-2">
              <Logo />
            </div>

            <div className="w-20 h-20 bg-red-50 rounded-full flex items-center justify-center mx-auto mb-6">
              <span className="text-4xl" role="img" aria-label="Fejl">⚠️</span>
            </div>

            <h1 className="text-2xl font-bold font-['Outfit'] mb-3">
              Noget gik galt
            </h1>
            <p className="text-[#71717A] mb-8">
              Der opstod en uventet fejl. Den er blevet logget, og vi kigger på det.
            </p>

            <div className="flex flex-col gap-3">
              <button
                onClick={this.handleReload}
                className="inline-flex items-center justify-center gap-2 bg-[#0A0A0A] text-white h-12 px-8 rounded-full font-bold hover:bg-[#0A0A0A]/90 transition-colors"
              >
                <RefreshCw className="w-4 h-4" />
                Genindlæs side
              </button>
              <a
                href="/"
                className="text-sm text-[#71717A] underline hover:text-[#0A0A0A]"
              >
                Tilbage til forsiden
              </a>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
